import { render, staticRenderFns } from "./FooterPolicy.vue?vue&type=template&id=d4b9c8f6&scoped=true&"
import script from "./FooterPolicy.vue?vue&type=script&lang=ts&"
export * from "./FooterPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./FooterPolicy.vue?vue&type=style&index=0&id=d4b9c8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9c8f6",
  null
  
)

export default component.exports